import React from "react";

const PILLARS = [
    {
        title: "Menu Management",
        blurb:
            "Update food & drink items once and keep menus consistent across your site.",
        href: "/solutions/menu",
        Icon: () => (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="16" rx="3" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M7 8h10M7 12h10M7 16h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
        ),
    },
    {
        title: "Online Ordering",
        blurb:
            "Accept pickup or delivery orders directly on your site. Simple, branded, and POS‑friendly.",
        href: "/solutions/ordering",
        Icon: () => (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path d="M4 7h16l-1.2 9.6A3 3 0 0 1 15.82 19H8.18A3 3 0 0 1 5.2 16.6L4 7Z" stroke="currentColor" strokeWidth="1.8"/>

                <circle cx="9" cy="20" r="1.6" fill="currentColor"/>
                <circle cx="15" cy="20" r="1.6" fill="currentColor"/>

                <path d="M4 7L3 3H1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        ),
    },
    {
        title: "Marketing & Events",
        blurb:
            "Promote specials, announce events, and capture emails with built‑in tools.",
        href: "/solutions/marketing",
        Icon: () => (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="6" width="18" height="15" rx="2" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M3 10h18" stroke="currentColor" strokeWidth="1.8"/>
                <path d="M7 4v4M17 4v4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>

                <path d="M12 13l.7 2.1h2.2l-1.8 1.3.7 2.1-1.8-1.3-1.8 1.3.7-2.1-1.8-1.3h2.2z" fill="currentColor"/>
            </svg>
        ),
    },
    {
        title: "Brand‑First Design",
        blurb:
            "A clean, mobile‑first site that feels like your venue. Fast, accessible, and modern.",
        href: "/solutions/design",
        Icon: () => (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="14" rx="2.5" stroke="currentColor" strokeWidth="1.8"/>
                <rect x="6" y="7" width="6" height="8" rx="1" fill="currentColor"/>
                <rect x="14" y="7" width="4" height="2.5" rx=".7" fill="currentColor"/>
                <rect x="14" y="10.5" width="4" height="2.5" rx=".7" fill="currentColor"/>
            </svg>
        ),
    },
];

export default function SolutionsHero() {
    return (
        <section className="solutions-intro">
            <div className="container">
                <div className="intro-head">
                    <span className="eyebrow">Solutions</span>
                    <h1 className="intro-title">
                        Everything your hospitality business needs in one platform.
                    </h1>
                    <p className="intro-sub">
                        Pick what you need now and add more later. Each solution works
                        together to keep your brand sharp and your guests coming back.
                    </p>
                </div>

                <div className="row gy-4 gx-4">
                    {PILLARS.map(({ title, blurb, href, Icon }, i) => (
                        <div className="col-12 col-md-6" key={title}>
                            <div className="pillar-card" aria-label={`${title} – learn more`}>
                                <div className="pc-icon">
                                    <Icon />
                                </div>
                                <div className="pc-copy">
                                    <h3 className="pc-title">{title}</h3>
                                    <p className="pc-blurb">{blurb}</p>
                                </div>
                                {/*<div className="pc-arrow" aria-hidden="true">→</div>*/}
                                <div className="col-1"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
